import type { Action } from '../App/types';
import type { ManageFloorPlanState } from './types';
import * as ActionTypes from './constants';

const initialState: ManageFloorPlanState = {
  floorPlans: [],
  floorPlansLoading: true,
};

const manageFloorPlansReducer = (
  state: ManageFloorPlanState = initialState,
  action: Action<*, *>,
): ManageFloorPlanState => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_ALL_FLOOR_PLANS: {
      return {
        ...state,
        floorPlansLoading: true,
      };
    }
    case ActionTypes.GET_ALL_FLOOR_PLANS_FAIL: {
      return {
        ...state,
        floorPlans: [],
        floorPlansLoading: false,
      };
    }
    case ActionTypes.CLEAR_ALL_FLOOR_PLANS: {
      return {
        ...state,
        floorPlans: [],
        floorPlansLoading: false,
      };
    }
    case ActionTypes.GET_ALL_FLOOR_PLANS_SUCCESS: {
      return { ...state, floorPlans: payload, floorPlansLoading: false };
    }

    default:
      return state;
  }
};

export default manageFloorPlansReducer;
